import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';
import {Alignment} from '../../../types';
import Headers, {HeaderType} from '../Text/Headers/Headers';

import './PageTitle.scss';

type Props = {
  text: string;
  className?: string;
};

function PageTitle({text, className}: Props): ReactElement {
  return (
    <Headers headerType={HeaderType.H2} className={cx('pageTitle', className)} alignment={Alignment.CENTER}>
      {text}
    </Headers>
  );
}

export default PageTitle;
